import React from 'react';
import PropTypes from 'prop-types';
import { State } from 'react-router';
import { getSignedUrl } from 'rawr/utils/retryPromise';
import isPreAPOrSpringboardSlug from 'utils/slug';


const preapBaseClickHelp = "https://collegeboard.clickhelp.co/articles";

const PREAP_COORDINATOR_MANUAL = {
  href: `${preapBaseClickHelp}/#!pre-ap-coordinator-manual-2021-22/pre-ap-classroom`,
  title: 'Pre-AP Classroom section of the Coordinator\'\s Manual',
  appendText: '(for coordinators and administrators), includes video supports',
  webLink: true
};
const PREAP_TEACHER_GUIDE = {
  href: `${preapBaseClickHelp}/pre-ap-classroom-user-guide-for-teachers/create-a-teacher-account`,
  title: 'Pre-AP Classroom User Guide for Teachers,',
  appendText: 'includes video supports',
  webLink: true
};
const PREAP_STUDENT_GUIDE = {
  href: `${preapBaseClickHelp}/pre-ap-classroom-user-guide-for-students/pre-ap-classroom-user-guide-for-students`,
  title: 'Pre-AP Classroom User Guide for Students,',
  appendText: 'includes video supports',
  webLink: true
};

const FAQ = React.createClass({
  mixins: [State],
  render () {
    if (current_user.anonymous) {
      return null;
    }
    const params = this.getParams();
    const course = params && (params.course || params.slug);
    const isPreApSubject = course ? isPreAPOrSpringboardSlug(course) : undefined;
    const showPreAPLinks = course === undefined || isPreApSubject === true ? true : false;
    const showAPLinks = course === undefined || isPreApSubject === false ? true : false;
    const { adminSubjects, teacherSubjects, studentSubjects } = window.current_user;

    const privileges = typeof current_user.privileges === 'string' ?
    JSON.parse(current_user.privileges) : {};
    const {
      is_student: isStudent, is_teacher: isTeacher, is_admin: isAdmin, is_coordinator: isCoordinator
    } = current_user;

    const PreAP = 'PRE-AP';
    const AP = 'AP';

    const isPreAPCoord = showPreAPLinks && (adminSubjects || []).some(subject => (subject.subjectProgram === PreAP)) && isCoordinator;

    const isPreAPTeacher = showPreAPLinks && teacherSubjects.some(subject => (subject.subjectProgram === PreAP));
    const isAPTeacher = showAPLinks && teacherSubjects.some(subject => (subject.subjectProgram === AP));
    const isPreAPStudent = showPreAPLinks && studentSubjects.some(subject => (subject.subjectProgram === PreAP));
    const isAPStudent = showAPLinks && studentSubjects.some(subject => (subject.subjectProgram === AP));
    const isAPAdmin = showAPLinks && adminSubjects.some(subject => (subject.subjectProgram === AP));
    const isPreAPAdmin = showPreAPLinks && adminSubjects.some(subject => (subject.subjectProgram === PreAP));


    const pdfBaseURL = `https://media.academicmerit.com/`;
    const apsupportFolder = `apsupport`;
    const apclassroomFolder = `apclassroom`;
    const apBaseClickHelp = "https://apclassroom.clickhelp.co/articles";
    const apTeacherGuide = `${apBaseClickHelp}/#!ap-classroom-user-guide-for-teachers-publication`;
    const apAdminCoordGuide = `${apBaseClickHelp}/#!ap-classroom-user-guide-for-administrators-and-coordinators/`;
    const apStudentGuide = `${apBaseClickHelp}/#!ap-classroom-user-guide-for-students`;


    let faqLink = `${apBaseClickHelp}/#!ap-classroom-faqs-publication`;

    const PDFS = {
      teacherGuides: {
        preap: {
          coordinator: [ PREAP_COORDINATOR_MANUAL, PREAP_TEACHER_GUIDE ],
          teacher: [ PREAP_TEACHER_GUIDE ],
          admin: [ PREAP_COORDINATOR_MANUAL, PREAP_TEACHER_GUIDE ]
        },
        ap: {
          default: [
            {
              href: apTeacherGuide,
              title: 'AP Teacher Guide to AP Classroom',
              webLink: true
            }
          ],
          coordinator: [
            {
              href: apAdminCoordGuide,
              title: 'AP Administrator and Coordinator Guide to AP Classroom',
              webLink: true
            }
          ],
          admin: [
            {
              href: apAdminCoordGuide,
              title: 'AP Administrator and Coordinator Guide to AP Classroom,',
              appendText: 'include video supports.',
              webLink: true
            }
          ]
        },
        behavioral: {
          path: '/teacher_guides/',
          default: [
            {
              href: 'Pilot_Guide_for_AP_Teachers_and_Administrators.pdf',
              title: 'Pilot Guide',
            },
            {
              href: 'Users_Guide_to_the_AP_Question_Bank.pdf',
              title: 'User\'s Guide to the Question Bank',
            }
          ]
        }
      },
      studentGuides: {
        preap: {
          coordinator: [ PREAP_STUDENT_GUIDE ],
          admin: [ PREAP_STUDENT_GUIDE ],
          teacher: [ PREAP_STUDENT_GUIDE ],
        },
        ap: {
          default: [
            {
              href: apStudentGuide,
              title: 'AP Student Guide to AP Classroom',
              webLink: true
            }
          ]
        },
        behavioral: {
          path: '/student_guides/',
          default: [
            {
              href: 'AP_Pilot_Guide_for_AP_Students_and_Parents_EN.pdf',
              title: 'AP® Student and Parent Pilot Guide',
            },
            {
              href: 'Guia_del_programa_piloto_para_estudiantes_y_padres_de_AP_2017-18_final.pdf',
              title: 'Guía del programa piloto para estudiantes y padres de AP®',
            },
            {
              href: 'Student_Guide_to_the_AP_Question_Bank.pdf',
              title: 'Student Guide to the Question Bank',
            }
          ]
        }
      }
    };

    /**
     * Store Pdf Items
     * @param {array} toArray The array where we store the new items.
     * @param {array} someArguments A list of arguments
     */
    const storePdfItems = (toArray, ...someArguments) => {
      const items = getPdfItems(...someArguments);
      if (items) {
        toArray.push(items);
      }
    };

    /**
     * Get pdf items list
     * @param {object} PDFS The pdf configuration object
     * @param {string} section First level - section [teacherGuides - studentGuides]
     * @param {string} ENV Second level - ENV [infra - behavioral]
     * @param {array} levelArguments The list of arguments sent by caller
     * @return {object} Path (to list of items) and List of items or NULL
     * */
    const getPdfItems = (PDFS, section, ENV, ...levelArguments) => {
      let itemsFound = true;
      const sectionPath = PDFS[section];
      const envPath = sectionPath && sectionPath[ENV] || null;
      let returnObj = null;
      let path;

      if (envPath) {
        path = envPath.path;
        let PDFSbyPath = envPath;
        levelArguments.forEach((level) => {
          if (PDFSbyPath[level]) {
            PDFSbyPath = PDFSbyPath[level];
          } else {
            itemsFound = false;
          }
        });

        if (itemsFound) {
          returnObj = {
            items: PDFSbyPath,
            path
          };
        }
      }

      return returnObj;
    };

    // Create a reference to the link for the href to be updated after the url is signed
    const linkRef = key => component => {
      getSignedUrl({ key, bucket: 'help.media.academicmerit.com' }).then((signedURL) => {
          React.findDOMNode(component).href = signedURL.replace(/\/[^\/]+\//, '/media.academicmerit.com/');
      });
    };

    const PDF_ENV = () => {
      if (isAPAdmin || isAPTeacher || isAPStudent) {
        return 'ap';
      } else if (isPreAPTeacher || isPreAPStudent || isPreAPCoord || isPreAPAdmin) {
        return 'preap';
      }
    }
    /**
     * Renders list of pdfs
     * @param {array|object} pdfItems List of items
     * @return React element
     * */
    const pdfRender = (pdfItems) => {

      const pilot = apclassroomFolder;
      const { path } = pdfItems;
      const baseDir = path ? `${pilot}${path}` : `${pilot}/`;

      return pdfItems.items.map((l, i) => {

        if (l.webLink) {
          return (
            <li key={i}>
              <p><a style={{ display: 'inline' }} href={l.href} target="_blank" rel="noopener noreferrer">{l.title}</a> {l.appendText}</p>
            </li>
          );
        }

        let key = `${baseDir}${l.href}`;
        return (
          <li key={i}>
            <a ref={linkRef(key)} target="_blank" href="#">{l.title}</a>
          </li>
        );
      });

    };

    const close = () => {
      // Return them to whence they came, or their homepage.
      const returnTo = location.query.return ? window.atob(location.query.return) : FYM_FRONTEND_URL;
      window.location = returnTo;
    };

    let teacherGuides = [];
    let studentGuides = [];

    let userType;
    if (isAdmin) {
      userType = 'admin';
    } else if (isCoordinator || isPreAPCoord) {
      userType = 'coordinator';
    } else if (isTeacher) {
      userType = 'teacher';
    } else if (isStudent) {
      userType = 'student';
    }

    if (isPreAPCoord) {
      storePdfItems(teacherGuides, PDFS, 'teacherGuides', 'preap', userType);
      if (isAPAdmin) {
        storePdfItems(teacherGuides, PDFS, 'teacherGuides', 'ap', userType);
        storePdfItems(teacherGuides, PDFS, 'teacherGuides', 'ap', 'default');
        storePdfItems(studentGuides, PDFS, 'studentGuides', 'ap', 'default');
      }
      storePdfItems(studentGuides, PDFS, 'studentGuides', 'preap', userType);
    } else if (userType === 'coordinator' || userType === 'admin') {
      storePdfItems(teacherGuides, PDFS, 'teacherGuides', PDF_ENV(), userType);
      storePdfItems(teacherGuides, PDFS, 'teacherGuides', PDF_ENV(), 'default');
      if (isPreAPCoord || isPreAPAdmin) {
        storePdfItems(studentGuides, PDFS, 'studentGuides', PDF_ENV(), userType);
      }
      storePdfItems(studentGuides, PDFS, 'studentGuides', PDF_ENV(), 'default');
    }

    if (isStudent) {
      storePdfItems(studentGuides, PDFS, 'studentGuides', PDF_ENV(), 'default');
    }

    return  (
      <div>
        <div className="help_links">
          { (isAPTeacher || isPreAPTeacher || isAPAdmin || isPreAPCoord || isPreAPAdmin) &&
            <ul>
              { (isAPAdmin || isAPTeacher) &&
                <li>
                   <h4>Frequently Asked Questions</h4>
                   <a href={faqLink} target="_blank">FAQ</a>
                </li>
              }
              {teacherGuides.length && <li>
                <h4>Educator Guides</h4>
                <ul>
                  {teacherGuides.map(item => pdfRender(item))}
                </ul>
              </li> || ''}
            </ul>
          }
          {studentGuides.length && <ul>
            <li>
              <h4>Student Guide</h4>
              <ul>
                {studentGuides.map(item => pdfRender(item))}
              </ul>
            </li>
          </ul> || ''}
        </div>
      </div>
    );
  }
});

export default FAQ;



/** WEBPACK FOOTER **
 ** collegeboard/client/rawr/controls/FAQ.jsx
 **/